'use client';

import React from 'react';
export var DropdownContext = /*#__PURE__*/React.createContext({
  values: [],
  items: [],
  open: false,
  selectedItems: [],
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  setOpen: function setOpen() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  setValues: function setValues() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  setItems: function setItems() {}
});
export var useDropdownContext = function useDropdownContext() {
  var context = React.useContext(DropdownContext);
  if (!context) {
    throw new Error('Dropdown compound components cannot be rendered outside the Dropdown component');
  }
  return context;
};